"use strict";

define('app/study/detail/study.detail.controller',['require','exports','module','rs/abstract.content.controller','../list/study.list.controller','rs/services/study.service','./study.detail.view','./document.detail.view','rs/modals/workflow/workflow.controller','rs/modals/meeting.finder/meeting.finder.controller','rs/modals/proposal.finder/proposal.finder.controller','rs/form/factory','rs/models/study','rs/models/pdf','rs/models/study.proposal','rs/models/product','e3-modal','e3-table','e3-common','evisions/validation','moment'],function (require, exports, module) {
  var AbstractContentController = require('rs/abstract.content.controller');
  var StudyListController = require('../list/study.list.controller');
  var StudyService = require('rs/services/study.service');
  var StudyDetailView = require('./study.detail.view');
  var DocumentDetailView = require('./document.detail.view');
  var WorkflowModal = require('rs/modals/workflow/workflow.controller');
  var MeetingFinder = require('rs/modals/meeting.finder/meeting.finder.controller');
  var ProposalFinder = require('rs/modals/proposal.finder/proposal.finder.controller');
  var FormFactory = require('rs/form/factory');
  var Study = require('rs/models/study');
  var PDFGenerator = require('rs/models/pdf');
  var StudyProposal = require('rs/models/study.proposal');
  var Product = require('rs/models/product');
  var E3Modal = require('e3-modal');
  var E3Table = require('e3-table');
  var E3Common = require('e3-common');
  var validation = require('evisions/validation');
  var moment = require('moment');
  var StudyDetailController = AbstractContentController.extend({
    name: 'Study Detail',
    contentName: 'study-detail-content abstract-content fixed-header off-white',
    footer: false,
    assignmentColumns: [{
      displayName: 'Team Member',
      namespace: 'person.displayName',
      width: '20%'
    }, {
      displayName: 'Role',
      namespace: 'assignmentType.displayName',
      width: '25%'
    }, {
      displayName: 'Number',
      namespace: 'person.primaryPhone.fullNumber',
      width: '20%'
    }, {
      displayName: 'Email',
      namespace: 'person.primaryEmail.emailAddress',
      width: '35%'
    }],
    documentColumns: [{
      name: 'templateType',
      displayName: 'Submission Type',
      width: '50%'
    }, {
      name: 'status',
      accessor: 'status',
      displayName: 'Status',
      width: '50%'
    }],
    properties: ['assignmentTable', 'documentDetailView', 'documentListView', 'documentService', 'selectedDocument', 'hasSp', 'studyService'],
    view: StudyDetailView,
    observes: {
      'create-meeting': 'navigateCreateMeeting'
    },
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.setStudyService(new StudyService());
      this.setAssignmentTable(new E3Table.Controller({
        delegate: this,
        columns: this.assignmentColumns,
        selectable: false,
        theme: 'rs'
      }));
      this.getAssignmentTable().setup(document.createElement('div'));
      this.setDocumentListView(E3Common.SidebarView.setup(document.createElement('div'), this));
      this.setDocumentDetailView(DocumentDetailView.setup(document.createElement('div'), this));
      this.getDocumentListView().applyProperties({
        title: 'Active Submissions',
        singleSelect: true
      });
      this.setupListeners();
      var view = this.getView();
      this.listenTo(view, 'link-proposal', this.requestLinkProposal);
      this.listenTo(view, 'unlink-proposal', this.requestUnLinkProposal);
    },
    generatePDFDocument: function generatePDFDocument(popup) {
      var studyService = this.getStudyService(),
        documents = studyService.getDocuments(),
        container = this.getView().getStudyDocumentPDFElement(this.getPDFProperties()),
        user = this.getAppController().getUser().getUsername(),
        that = this;
      return Promise.map(documents, function (doc) {
        return FormFactory.createFormPDFViewer(doc.getId(), user, that.getAppController()).then(function (formController) {
          formController.setAppController(that.getAppController());
          formController.setup(container.find('#doc-id-' + doc.id));
          return formController.getView().setupPDFElement();
        });
      }).tap(function () {
        PDFGenerator.requestCreatePDF(container.get(0), popup);
      }).lastly(this.showLoading());
    },
    getDocPDFProperties: function getDocPDFProperties(doc) {
      var assignmentsMap = this.getStudyService().getAssignments().getMap();
      return {
        createDate: doc.createDate ? moment(doc.createDate).format('l') : null,
        date: moment().format('l'),
        doc: doc,
        status: E3Common.String.toProperCase(doc.status),
        assignments: assignmentsMap
      };
    },
    getPDFProperties: function getPDFProperties(doc) {
      var studyService = this.getStudyService(),
        study = studyService.getStudy();
      return {
        assignments: study.getAssignments(),
        assignmentsMap: study.getAssignmentMap(),
        createDate: study.createDate ? moment(study.createDate).format('l') : null,
        date: moment().format('l'),
        expirationDate: study.expirationDate ? moment(study.expirationDate).format('l') : null,
        doc: doc,
        documents: studyService.getDocuments(),
        study: study
      };
    },
    getTemplateProperties: function getTemplateProperties() {
      var studyService = this.getStudyService(),
        app = this.getAppController(),
        assignments = studyService.getAssignments(),
        study = studyService.getStudy(),
        orgs = study.getOrganizations();
      return {
        previousPage: StudyListController.prototype.name,
        title: study.title,
        label: study.label,
        status: study.status,
        statusColor: this.mapStatusToColor(study.status),
        sponsor: study.sponsor,
        multiOrgs: orgs && orgs.length > 1 ? true : false,
        organizations: studyService.getOrganizationSummary(),
        reviewBoard: study.reviewBoard,
        documents: studyService.getDocuments(),
        studyProposals: studyService.getStudyProposals(),
        canLinkProposals: this.getHasSp() && studyService.canLinkProposals(),
        contact: assignments.getOnePerson('PRINCIPAL_INVESTIGATOR'),
        assignments: assignments.getAssignments(),
        approvalDate: study.approvalDate,
        expirationDate: study.expirationDate,
        adminCheckinDate: study.adminCheckinDate,
        finalizedDate: study.finalizedDate
      };
    },
    mapStatusToColor: function mapStatusToColor(status) {
      var statusColor = null;
      switch (String(status).toUpperCase()) {
        case 'APPROVED':
          statusColor = 'success';
          break;
        case 'DISAPPROVED':
          statusColor = 'danger';
          break;
        case 'SUSPENDED':
        case 'EXPIRED':
        case 'REQUIRES CHANGES':
          statusColor = 'warning';
          break;
        case 'CLOSED':
        case 'WITHDRAWN':
          statusColor = 'info';
          break;
      }
      return statusColor;
    },
    userHasPermission: function userHasPermission(perm) {
      var user = this.getAppController().getUser();
      return user.getPerson().hasPermission(perm);
    },
    start: function start(id, documentId) {
      var view = this.getView(),
        studyService = this.getStudyService();
      studyService.configure({
        studyId: id
      });
      return this.loadStudyProperties().bind(this).spread(function (study, documents) {
        if (!_.isEmpty(documents)) {
          this.setSelectedDocument(studyService.getInitialDocument(documentId));
        }
        this.updateDocumentTitle();
        return Product.findByName('SP');
      }).tap(function (product) {
        this.setHasSp(!!product);
        return this.getAssignmentTable().start();
      }).tap(this.showLoading());
    },
    getDocumentTitle: function getDocumentTitle() {
      var studyService = this.getStudyService(),
        studyId = studyService.getStudyId();
      if (studyId) {
        return 'Study - ' + studyService.getStudy().label;
      }
    },
    loadStudyProperties: function loadStudyProperties() {
      return this.getStudyService().load('study', 'documents', 'templates', 'assignments', 'analysts', 'studyProposals');
    },
    setupListeners: function setupListeners() {
      var studyService = this.getStudyService(),
        documentListView = this.getDocumentListView(),
        documentDetailView = this.getDocumentDetailView(),
        selectedDoc = this.getSelectedDocument(),
        view = this.getView();
      function refreshDocumentsVisibility() {
        if (_.isEmpty(studyService.getDocuments())) {
          view.getDocumentsContainer().hide();
          view.showDeleteBtn();
        } else {
          view.getDocumentsContainer().show();
          view.hideDeleteBtn();
        }
      }
      function refreshStudyDetails() {
        this.loadStudyProperties().bind(this).tap(this.render).tap(refreshDocumentsVisibility).tap(refreshTemplates);
      }
      function refreshTemplates() {
        view.refreshCreateStudyButton(studyService.getTemplates());
      }
      documentListView["interface"]('requestActivateItem', function (item) {
        this.setSelectedDocument(item.document);
      });
      this.listenTo(studyService, 'change:documents', function () {
        var docs = studyService.getDocuments();
        function processDocument(doc) {
          var resultDate = doc.getDecisionResultDate();
          return {
            title: doc.templateType,
            id: doc.id,
            document: doc,
            status: this.getStatusForDocument(doc),
            resultDate: resultDate && doc.finalized ? moment(resultDate).format('MM/DD/YYYY') : ''
          };
        }
        var openDocuments = _.map(studyService.getOpenDocuments(), processDocument, this),
          finalizedDocuments = _.map(studyService.getFinalizedDocuments(), processDocument, this),
          sections = [{
            items: openDocuments,
            template: 'sidebar.section.document'
          }];
        if (!_.isEmpty(finalizedDocuments)) {
          sections.push({
            title: 'Study History',
            items: finalizedDocuments,
            template: 'sidebar.section.document'
          });
        }
        documentListView.render(sections);
        refreshDocumentsVisibility();
        if (this.hasStarted() && _.indexOf(docs, this.getSelectedDocument()) < 0) {
          this.setSelectedDocument(studyService.getInitialDocument());
        }
      });
      this.listenTo(studyService, 'change:templates', refreshTemplates);
      this.listenTo(studyService, 'change:study', refreshStudyDetails);
      this.listenTo(studyService, 'change:studyProposals', refreshStudyDetails);
      this.listenTo(this, 'change:hasSp', refreshStudyDetails);
      this.listenTo(studyService, 'change:assignments', function () {
        this.getAssignmentTable().refresh();
      });
      this.listenTo(view, 'change:rendered', refreshDocumentsVisibility);
      this.listenTo(view, 'change:rendered', function () {
        view.refreshCreateStudyButton(studyService.getTemplates());
      });
      this.listenTo(this, 'change:selectedDocument', function () {
        var doc = this.getSelectedDocument(),
          documentService = this.getDocumentService(),
          app = this.getAppController(),
          studyService = this.getStudyService(),
          openDocuments = studyService.getOpenDocuments();
        if (documentService) {
          this.stopListening(documentService);
          studyService.stopListening(documentService);
          documentService.destroy();
        }
        if (!doc) {
          return;
        }
        documentListView.selectItem(doc.id);
        documentService = studyService.documentService(doc.id);
        this.setDocumentService(documentService);
        this.refreshDocumentDetailView().bind(this).tap(function () {
          this.getDocumentDetailView().resetTab();
          this.listenTo(documentService, 'change:document', this.refreshDocumentDetailView);
          this.listenTo(documentService, 'change:decisions', this.refreshDocumentDetailView);
          this.listenTo(documentService, 'change:assignments', this.refreshDocumentDetailView);
          this.listenTo(documentService, 'change:meetings', this.refreshDocumentDetailView);
          this.listenTo(documentService.getWorkflowService(), 'change:taskSummaries', this.refreshDocumentDetailView);
          this.listenTo(documentService.getWorkflowService(), 'change:taskHistory', this.refreshDocumentDetailView);
        });
      });
      this.listenTo(documentDetailView, 'change:tab', function () {
        view.refreshDocumentListContainerHeight();
      });
    },
    refreshDocumentDetailView: function refreshDocumentDetailView() {
      return this.getDocumentService().load(['document', 'permissions', 'workflowService.tasks', 'workflowService.taskSummaries', 'workflowService.taskHistory', 'decisions', 'decisionTypes', 'assignments', 'meetings', 'letters', 'checklists']).bind(this).tap(this.renderDocumentDetail).lastly(this.showLoading());
    },
    renderDocumentDetail: function renderDocumentDetail() {
      this.getDocumentDetailView().render(this.getDocumentDetails());
    },
    render: function render() {
      var assignmentTable = this.getAssignmentTable(),
        documentListView = this.getDocumentListView(),
        documentDetail = this.getDocumentDetailView(),
        view = this.getView();
      assignmentTable.view.$el.detach();
      documentDetail.$el.detach();
      documentListView.$el.detach();
      this._super(this.getTemplateProperties());
      view.getAssignmentTableContainer().html(assignmentTable.view.$el);
      view.getDocumentListContainer().html(documentListView.$el);
      view.getDocumentDetailContainer().html(documentDetail.$el);
      view.renderFooter();
      view.refreshDocumentListContainerHeight();
      view.refreshContentSizing();
    },
    requestStudyTitleChange: function requestStudyTitleChange(newTitle) {
      var studyService = this.getStudyService(),
        study = studyService.getStudy();
      if (newTitle == study.getTitle()) {
        this.getView().refreshStudyFields();
        return;
      }
      return studyService.updateStudy({
        title: newTitle
      }).bind(this).tap(function () {
        this.getView().refreshStudyFields();
      }).lastly(this.showLoading());
    },
    requestCreateDocument: function requestCreateDocument(templateId, revisionNumber) {
      var template = _.findWhere(this.getStudyService().getTemplates(), {
        id: templateId,
        revisionNumber: revisionNumber
      });
      if (template) {
        return this.getStudyService().createDocument(template).lastly(this.showLoading());
      }
    },
    requestAssignAnalyst: function requestAssignAnalyst(newAnalyst) {
      if (newAnalyst) {
        return this.getDocumentService().assignAnalyst(newAnalyst.getId()).lastly(this.showLoading());
      }
    },
    requestDocumentDeleteConfirm: function requestDocumentDeleteConfirm() {
      return E3Modal.BtnMsgModal.show({
        title: 'Warning',
        message: 'Are you sure you want to delete this document?',
        buttons: ['NO', {
          text: 'YES',
          color: 'danger'
        }]
      }).then(function (btn) {
        if (btn != 'YES') {
          return Promise.reject().ignore();
        }
      });
    },
    requestStudyDelete: function requestStudyDelete() {
      var studyService = this.getStudyService();
      return this.requestStudyDeleteConfirm(studyService.getStudy()).bind(this).tap(function () {
        return studyService.deleteStudy();
      }).tap(this.requestNavigatePrevious);
    },
    requestStudyDeleteConfirm: function requestStudyDeleteConfirm(study) {
      return E3Modal.BtnMsgModal.show({
        title: 'Warning',
        message: 'Are you sure you want to delete "' + study.getTitle() + '" Study?',
        buttons: ['NO', {
          text: 'YES',
          color: 'danger'
        }]
      }).then(function (btn) {
        if (btn != 'YES') {
          return Promise.reject().ignore();
        }
      });
    },
    createDocumentPdf: function createDocumentPdf(popup) {
      var doc = this.getDocumentService().getDocument(),
        data = this.getDocPDFProperties(doc),
        user = this.getAppController().getUser().getUsername(),
        container = this.getView().getStudyDocumentPDFElement(data);
      FormFactory.createFormPDFViewer(doc.getId(), user, this.getAppController()).bind(this).then(function (formController) {
        formController.setAppController(this.getAppController());
        formController.setup(container.find('.pdf-form-container'));
        return formController.getView().setupPDFElement();
      }).then(function () {
        PDFGenerator.requestCreatePDF(container.get(0), popup);
      }).lastly(this.showLoading());
    },
    deleteDocument: function deleteDocument() {
      return this.requestDocumentDeleteConfirm().bind(this).then(function () {
        return this.getDocumentService().deleteDocument().lastly(this.showLoading());
      });
    },
    requestApplyWorkflowAnswer: function requestApplyWorkflowAnswer(value) {
      var workflowService = this.getDocumentService().getWorkflowService();
      if (workflowService.hasTask('EDIT_COMPLETE') || workflowService.hasTask('IRB_LEGACY_COMPLETE') || workflowService.hasTask('IRB_ADMIN_EDIT')) {
        return this.navigateDocumentEdit();
      }
      return WorkflowModal.show({
        workflowService: workflowService,
        answerValue: value
      }).bind(this).tap(function () {
        return workflowService.answerTask(value).lastly(this.showLoading());
      });
    },
    requestDocumentActivity: function requestDocumentActivity(activity) {
      switch (activity) {
        case 'edit':
        case 'assignPrimaryContact':
        case 'assignPrincipalInvestigator':
        case 'openDocument':
          this.navigateDocumentEdit();
          break;
        case 'setupBoard':
          this.navigateSetupBoard();
          break;
        case 'delete':
          this.deleteDocument();
          break;
        case 'createPDF':
          this.createDocumentPdf();
          break;
        case 'makeDecision':
          this.navigateDocumentDecision();
          break;
        case 'manageLetters':
          this.navigateDocumentLetters();
          break;
        case 'createMeeting':
          this.navigateCreateMeeting();
          break;
        case 'assignToMeeting':
          this.requestAssignMeetings();
          break;
        case 'showChecklist':
          this.getAppController().store.set('document.edit.checklist', true);
          this.navigateDocumentEdit(true);
          break;
      }
    },
    requestAssignMeetings: function requestAssignMeetings() {
      var documentService = this.getDocumentService();
      return MeetingFinder.show({
        board: documentService.getAssignments().getOneGroup('IRB_BOARD'),
        items: documentService.getOpenMeetings()
      }).tap(function (meetings) {
        documentService.assignMeetings(meetings);
      });
    },
    requestUnLinkProposal: function requestUnLinkProposal(proposalId) {
      var studyService = this.getStudyService(),
        studyId = studyService.getStudy().getId();
      return StudyProposal.destroyLink(proposalId, studyId).bind(this).tap(function () {
        return studyService.update('studyProposals');
      }).lastly(this.showLoading());
    },
    requestLinkProposal: function requestLinkProposal() {
      var studyService = this.getStudyService(),
        studyId = studyService.getStudy().getId(),
        studyProposals = studyService.getStudyProposals(),
        proposalIds = _.pluck(studyProposals, 'proposalId'),
        researchers = studyService.getResearchPeople();
      return ProposalFinder.show({
        items: _.pluck(studyProposals, 'proposal'),
        people: researchers
      }).bind(this).tap(function (proposals) {
        var newIds = _.pluck(proposals, 'id'),
          added = _.difference(newIds, proposalIds),
          removed = _.difference(proposalIds, newIds),
          promises = [];
        for (var i = 0, len = added.length, proposalId; i < len; i++) {
          proposalId = added[i];
          promises.push(StudyProposal.createLink(proposalId, studyId, _.findWhere(proposals, {
            id: proposalId
          })));
        }
        for (var i = 0, len = removed.length, proposalId; i < len; i++) {
          proposalId = removed[i];
          promises.push(StudyProposal.destroyLink(proposalId, studyId));
        }
        return Promise.all(promises).tap(function () {
          if (!_.isEmpty(promises)) {
            return studyService.update('studyProposals');
          }
        }).lastly(this.showLoading());
      });
    },
    requestNavigatePrevious: function requestNavigatePrevious() {
      var app = this.getAppController();
      if (app.lastPage() && app.lastPage().name == StudyListController.prototype.name) {
        app.navigateBack();
      } else {
        app.navigateNewStudyList({
          trigger: true
        });
      }
    },
    requestMeetingById: function requestMeetingById(id) {
      var meeting = {
        id: id
      };
      if (this.getDocumentService()) {
        meeting.documentId = this.getDocumentService().getDocumentId();
      }
      this.getAppController().navigateMeeting(meeting, {
        trigger: true
      });
    },
    requestDocumentDecisionById: function requestDocumentDecisionById(id) {
      this.navigateDecision(id);
    },
    requestDocumentLetterById: function requestDocumentLetterById(id) {
      var letters = this.getDocumentService().getLetters(),
        doc = this.getDocumentService().getDocument(),
        docLetter = _.findWhere(letters, {
          id: id
        }),
        popup = PDFGenerator.generatePopup();
      if (docLetter) {
        docLetter.requestCurrentContent(doc.getId()).then(function (content) {
          PDFGenerator.requestCreatePDF(content, popup);
        }).lastly(this.showLoading());
      }
    },
    requestPromoteDecision: function requestPromoteDecision(decisionId) {
      E3Modal.BtnMsgModal.show({
        title: 'Warning',
        message: 'Are you sure you want to promote this decision? Continuing will discard the current submission decision.',
        buttons: ['NO', {
          text: 'YES',
          color: 'danger'
        }]
      }).bind(this).then(function (btn) {
        if (btn == 'YES') {
          this.getDocumentService().promoteDecision(decisionId).bind(this).tap(this.refreshDocumentDetailView).lastly(this.showLoading());
        }
      });
    },
    setupChildDecisions: function setupChildDecisions() {
      var documentService = this.getDocumentService(),
        openDecision = documentService.getOpenDecision(),
        childDecisions = openDecision ? openDecision.getChildren() : [],
        assignments = documentService.getAssignments();
      return _.map(childDecisions, function (decision) {
        var assignment = assignments.getOneByPersonId(decision.responsiblePerson.id);
        return _.extend({
          responsiblePersonAssignment: assignment ? assignment.assignmentType : ''
        }, decision);
      });
    },
    getStatusForDocument: function getStatusForDocument(doc) {
      if (doc.getFinalizedDate() && doc.getDecisionStatus()) {
        return String(doc.getDecisionStatus()).toUpperCase();
      } else if (doc.getFinalizedDate() && doc.getTemplateType() == 'Closure' && !doc.getDecisionStatus()) {
        return 'CLOSED';
      } else if (doc.getFinalizedDate() && doc.getTemplateType() == 'Withdrawal' && !doc.getDecisionStatus()) {
        return 'WITHDRAWN';
      } else {
        return String(doc.getStatus()).toUpperCase();
      }
    },
    getDocumentDetails: function getDocumentDetails() {
      var currentUser = this.getAppController().getUser(),
        documentService = this.getDocumentService(),
        workflowService = documentService.getWorkflowService(),
        responsibleDecision = documentService.getResponsibleDecision(true),
        taskSummaries = workflowService.getTaskSummaries(),
        history = workflowService.getTaskHistory(),
        childDecisions = this.setupChildDecisions(),
        finalizedDecisions = documentService.getFinalizedDecisions(),
        documentStatus = this.getStatusForDocument(documentService.getDocument());
      return _.extend({}, documentService.cache.get(), workflowService.cache.get(), {
        assignments: documentService.getAssignments().getSimpleMap(),
        actions: documentService.getDocumentActions(),
        taskAnswers: workflowService.getTaskAnswers(),
        taskOperations: workflowService.getTaskOperations(),
        withdrawal: documentService.getDocument().isWithdrawal(),
        selectedDecisionTypeId: E3Common.Object.namespace(responsibleDecision, 'decisionType.id'),
        task: workflowService.getTask(),
        decisions: finalizedDecisions,
        openMeetings: documentService.getOpenMeetings(),
        showDecisionsTab: childDecisions.length > 0 || finalizedDecisions.length > 0,
        childDecisions: childDecisions,
        promoteDecisions: documentService.canPromoteDecisions(),
        responsibleDecision: responsibleDecision,
        canMakeExpeditedDecision: workflowService.canMakeChildDecision(),
        currentUserDisplayName: currentUser.getDisplayName(),
        currentUserAssignments: documentService.getCurrentUserAssignments(),
        hasTaskSummaries: !_.isEmpty(taskSummaries.CERTIFY) || !_.isEmpty(taskSummaries.ORG_APPROVED),
        hasHistory: !_.isEmpty(history.CERTIFY) || !_.isEmpty(history.ORG_APPROVED),
        status: documentStatus,
        statusColor: this.mapStatusToColor(documentStatus)
      });
    },
    getData: function getData(table) {
      return Promise.resolve(this.getStudyService().getStudy()).bind(this).then(function (study) {
        return study.getAssignments();
      });
    },
    navigateDocumentEdit: function navigateDocumentEdit() {
      var documentService = this.getDocumentService();
      return this.getAppController().navigateDocument(documentService.getDocument(), {
        trigger: true
      });
    },
    navigateSetupBoard: function navigateSetupBoard() {
      var documentService = this.getDocumentService();
      this.getAppController().navigateSetupBoard(documentService.getDocument(), {
        trigger: true
      });
    },
    navigateDecision: function navigateDecision(id) {
      this.getAppController().navigateDecision(id == null ? null : {
        id: id
      }, {
        trigger: true
      });
    },
    navigateDocumentDecision: function navigateDocumentDecision() {
      var documentService = this.getDocumentService();
      this.getAppController().navigateDocumentDecision(documentService.getDocument(), {
        trigger: true
      });
    },
    navigateDocumentLetters: function navigateDocumentLetters() {
      var documentService = this.getDocumentService();
      this.getAppController().navigateDocumentLetters(documentService.getDocument(), {
        trigger: true
      });
    },
    navigateCreateMeeting: function navigateCreateMeeting() {
      this.getAppController().navigateCreateMeeting({
        trigger: true
      });
    }
  });
  module.exports = StudyDetailController;
});

